// extracted by mini-css-extract-plugin
module.exports = {"popUp":"_4eiB3MwHnHl1FvBB9b0pG","closeButton":"_37fNVWMTz3bhYF_PVduyC6"};